import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { AppConfigService } from '../http-services/app-config.service';

@Injectable()
export class SubscriptionLockInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private appConfig: AppConfigService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.isSubscriptionLockError(error)) {
          this.redirectToSubscriptionEntry();
        }
        return throwError(() => error);
      })
    );
  }

  private static readonly subscriptionDeniedCode = 40301;

  private isSubscriptionLockError(error: HttpErrorResponse): boolean {
    if (error.status !== 403) return false;

    const payload = error?.error;
    const code = Number(payload?.errorCode);
    if (code === SubscriptionLockInterceptor.subscriptionDeniedCode) {
      return true;
    }

    const errors: string[] = Array.isArray(payload?.errors)
      ? payload.errors.map((e: unknown) => String(e))
      : [];
    const message = `${payload?.message ?? ''} ${errors.join(' ')}`.toLowerCase();

    return (
      message.includes('trial ended')
      || message.includes('subscribe to continue')
      || message.includes('subscription is required')
      || message.includes('subscription required')
    );
  }

  private redirectToSubscriptionEntry(): void {
    const current = this.router.url || '';
    const role = (this.authService.getUserRole() || '').toLowerCase();

    if (role === 'candidate' && !this.appConfig.isCandidatePaywallEnabled()) {
      return;
    }

    if (role === 'provider') {
      if (!current.startsWith('/app/provider/platform-subscription')) {
        this.router.navigateByUrl('/app/provider/platform-subscription');
      }
      return;
    }

    if (!current.startsWith('/app/candidate/platform-subscription')) {
      this.router.navigateByUrl('/app/candidate/platform-subscription');
    }
  }
}
